module.exports = "img/368bd6.2349bd1.png";